const eventsToListen = [
    "mousemove",
    "scroll",
    "keydown",
    "resize",
    "touchmove",
    "touchend",
];

export class ActivityTracker {
    private userActivityThrottlerTime: number;
    private inactiveTimeoutThreshold: number;
    private userInactiveCallback: VoidFunction;
    private userInactiveTimeout: any;
    private userInactiveThrottlerTimeout: any;

    /**
     * @param inactiveTime specifies after which time of inactivity the userInactiveCallback gets called 
     * @param userInactiveCallback gets called after specified time of user inacitivity
     */
    constructor(inactiveTime: number, userInactiveCallback: VoidFunction) {
        this.inactiveTimeoutThreshold = inactiveTime;
        this.userInactiveCallback = userInactiveCallback;
        // specify throttler to 1/30 of inactiveTimeoutThreshold with 500 ms being lower limit
        this.userActivityThrottlerTime = Math.max(this.inactiveTimeoutThreshold / 30, 500);
    }

    public setupActivityTracker(): void {
        eventsToListen.forEach(evtName => {
            window.addEventListener(evtName, this.userActivityThrottler.bind(this));
        });
    };

    public stopActivityTracker(): void {
        eventsToListen.forEach(evtName => {
            window.removeEventListener(evtName, this.userActivityThrottler.bind(this));
        });
        clearTimeout(this.userInactiveTimeout);
        clearTimeout(this.userInactiveThrottlerTimeout);
    };

    /// throttle calling user inactive timeout
    // resetted when user performs action
    private userActivityThrottler(): void {
        if (!this.userInactiveThrottlerTimeout) {
            // when user did not perform any action and throttler timeout not called yet
            this.userInactiveThrottlerTimeout = setTimeout(() => {
                this.resetUserInactiveTimeout();
                clearTimeout(this.userInactiveThrottlerTimeout);
                this.userInactiveThrottlerTimeout = null;
            }, this.userActivityThrottlerTime);
        }
    };

    private resetUserInactiveTimeout(): void {
        clearTimeout(this.userInactiveTimeout);
        this.userInactiveTimeout = setTimeout(this.userInactiveCallback, this.inactiveTimeoutThreshold);
    };
}